export default {
    state: {
      tableData:[]
    },
    mutations: {
        handelTableData(state,val){
            state.tableData =val
        },
    
    },
    actions: {
  
    },
  
}